import ReportManager7 from "./ReportManager/route.js";
import UserProfile8 from "./UserProfile/route.js";

export default [
  ReportManager7,
  UserProfile8,
];